import createHistory from 'history/lib/createBrowserHistory';
export default createHistory();



/** WEBPACK FOOTER **
 ** ./frontend/utils/history.js
 **/